import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ClearRefinements, connectMenu } from 'react-instantsearch-dom';
import foreach from 'lodash.foreach';
import sortByOrder from 'lodash.sortbyorder';
import Link from '@utility/Link';
import FluidImage from '@utility/FluidImage';
import cn from 'classnames';
import * as styles from './styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import ScrollInView from '@utility/ScrollInView/index';
import QuoteCarousel from '../QuoteCarousel';

let finishCount = null;

const Menu = ({
  items,
  refine,
  createURL,
  productFinishes,
  finishCategoriesData,
}) => {
  let modifiedItems = [];
  let finishCategories = [];

  foreach(items, (item) => {
    productFinishes &&
      productFinishes.find((finish) => {
        if (item.label === finish.node.code) {
          item = {
            ...item,
            title: finish.node.title,
            image: finish.node.image,
            orderRank: finish.node.orderRank,
            category: finish.node.category.title,
          };

          // prettier-ignore
          const category = finishCategoriesData.find(category => category.node.title === item.category);

          const modifiedCategory = category ? {
            title: category.node.title,
            orderRank: category.node.orderRank,
            isHidden: category.node.isHidden,
          } : {};

          // Only add unique finish categories that are not hidden
          // prettier-ignore
          if (
            !modifiedCategory.isHidden &&
            !finishCategories.some((category) => category.title === modifiedCategory.title)
          ) {
            finishCategories.push(modifiedCategory);
          }

          modifiedItems.push(item);
        }
      });
  });

  const finishCategoryTitles = finishCategories.map(
    (category) => category.title,
  );

  // Filter out finishes that are not included as finish categories
  modifiedItems = modifiedItems.filter((item) => {
    return finishCategoryTitles.includes(item.category);
  });
  modifiedItems = sortByOrder(modifiedItems, ['orderRank'], ['asc']);
  finishCategories = sortByOrder(finishCategories, ['orderRank'], ['asc']);
  finishCount = modifiedItems.length;

  return (
    <div>
      {finishCategories.map((category) => (
        <div key={category.title} className={cn(styles.finishMenuCategory)}>
          <h2 className="type-sans-630 sm-down:mb-2">{category.title}</h2>
          <ul className={styles.finishMenuList}>
            {
              modifiedItems.filter((e) => e.category === category.title)
              .map((item, index) => (
                <li
                key={item.value + index }
                className={cn(styles.finishMenuItem, {
                  ['bg-white']: item.isRefined,
                })}
              >
                <div className="mb-2">
                  <FluidImage
                    src={item.image}
                    max-width={280}
                    max-height={420}
                    loading="eager"
                  />
                </div>
                <a
                  href={createURL(item.value)}
                  className={styles.finishMenuLink}
                  onClick={(event) => {
                    event.preventDefault();
                    refine(item.value);
                  }}
                >
                  <p className="type-sans-130">{item.title}</p>
                </a>
              </li>
              ))
            }
          </ul>
        </div>
      ))}
    </div>
  );
};

const CustomMenu = connectMenu(Menu);

const ProductFinishMenu = ({
  productFinishes,
  finishCategoriesData,
  isOpen,
}) => {
  const finishCountRef = useRef();

  useEffect(() => {
    finishCountRef.current.innerHTML =
      finishCount.length == 1
        ? finishCount + ' finish available'
        : finishCount + ' finishes available';
  });

  return (
    <div
      className={cn(styles.finishMenu, {
        [styles.animate]: isOpen,
      })}
    >
      <div className='mb-10 md:mb-12'>
        <p className="type-upper-070 mt-12 mb-2" ref={finishCountRef}></p>
        <div className="md:flex md:justify-between md:items-center mb-10 md:mb-12">
          <p className="type-sans-230 mb-6 md:mb-0">
            Want to compare these finishes in hand? 
            <Link
              to="/finishes"
              className="type-sans-240 md:ml-1 mr-1"
              aria-label="Order finish samples"
            >
              Order samples
            </Link>
            from our finish library with free next day shipping.
          </p>
          {/* Commenting clear filters as per client request  */}
          {/* <ClearRefinements
            transformItems={(items) =>
              items.filter(
                ({ attribute }) => attribute == 'productFinish.finish.code',
              )
            }
            translations={{
              reset: 'Clear Selection',
            }}
          /> */}
        </div>
      </div>
      <CustomMenu
        attribute="productFinish.finish.code"
        productFinishes={productFinishes}
        finishCategoriesData={finishCategoriesData}
        limit={100}
      />
    </div>
  );
};

ProductFinishMenu.propTypes = {
  productFinishes: PropTypes.array,
  finishCategoriesData: PropTypes.array,
};

ProductFinishMenu.defaultProps = {
  productFinishes: null,
  finishCategoriesData: null,
};

export default ProductFinishMenu;
